export default {
  bind(el,bindings){
    const permissions = window.sessionStorage.getItem("rolePermission");
    const needPermission = bindings.value;
    if(permissions == needPermission){
      el.style.display = 'none';
      setTimeout(()=>{
        el.parentNode.removeChild(el)
      },0)
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./directive/has.js
// module id = null
// module chunks = 